import styled from 'styled-components';
import CurrencyInput from 'react-currency-input-field';

import Colors from '../../config/Colors';

export const CurrencyInputMask = styled(CurrencyInput)`
    font-size: 16px;
    font-family: NunitoSans-Regular;
    border-radius: 4px;
    min-height: 45px;
    padding: 8.5px 12px 8.5px 12px;
    border: 1px solid ${Colors.border};
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    border-color: ${({ $hasAnError }) =>
        $hasAnError ? `${Colors.danger}` : null};

    &:focus {
        border: 1px solid
            ${({ $hasAnError }) => $hasAnError && `${Colors.danger}`};
        outline: ${({ $hasAnError }) =>
            $hasAnError ? `${Colors.danger}` : null};
    }
`;
